import {AbbreviationMap} from './abbreviationProcessor';

export const parseFootnotes = (footnotesContent: string): AbbreviationMap => {
  const footnoteMap: AbbreviationMap = {};

  if (!footnotesContent) {
    return footnoteMap;
  }

  // Regex pattern to match footnotes in plain text or HTML format (e.g. <p>[1] ...</p><p>[2] ...</p>):
  // Start boundary: Start of string, newline, or HTML block/break tag (<p>, <br>, <div>, <li>)
  // Footnote marker: \[(\d+)\]
  // Footnote content: (.*?)
  // End boundary lookahead: Next footnote definition (start/newline/tag + \[\d+\]) OR end of string
  const footnoteRegex = /(?:^|\r?\n|<\/?(?:p|div|li|br)\b[^>]*>)\s*\[(\d+)\]\s*(.*?)(?=(?:(?:\r?\n|<\/?(?:p|div|li|br)\b[^>]*>)\s*\[\d+\])|$)/gis;

  let match;
  while ((match = footnoteRegex.exec(footnotesContent)) !== null) {
    const footnoteNumber = match[1];
    let footnoteContent = match[2].trim();

    // Strip trailing HTML closing/break tags if present at the end of footnote content (e.g., </p>, </div>, <br>)
    footnoteContent = footnoteContent.replace(/(?:<\/(?:p|div|li|span)>|<br\s*\/?>|\s)+$/gi, '').trim();

    footnoteMap[`[${footnoteNumber}]`] = footnoteContent;
  }
  return footnoteMap;
};

